/* eslint-disable react/jsx-pascal-case */
import {
  CmpSelectBox,
  CmpButton,
  CmpDatePicker,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {
  INVBTOUT_Attribute_GETROW,
  INVBTOUT_Summary_GETROW,
  common_locaitonlist_API,
} from "../../Server/ApiV2";
import { useSelector } from "react-redux";
import {
  Set_SummaryObj,
  Set_HeadObj,
  Set_HeadObj_DetailHead_Update,
} from "./SliceBatchOut";

import { GetGitterColumns } from "../../Utility/Utilitys";
import moment from "moment";
import BreadCrumbs from "./BreadCrumbs";
import useMediaQuery from "@mui/material/useMediaQuery";
import { SummaryTblCard } from "./processComponent/SummaryTblCard";
import GCSummaryModal from "../../Component/Common/ReuseableComponent/GCSummaryModal";
import { CardSummary } from "./processComponent/CardDesign";
import { BatchOutRo, vRdxUserInfo } from "../../Redux/roStore";
import { GetSIDetailVersion } from "./Action";
import {
  CmpDatePickerField001V1,
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../Component/Common/ToolBox/ToolBoxV1";
import GCModalBatch from "./processComponent/GCModalBatch";
import GCModalV1 from "../../Component/Common/ReuseableComponent/GCModalV1";
import { SummaryTblCardV1 } from "./processComponent/SummaryTblCardV1";

export default function BatchOut() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const LocationFocusOnLoad = useRef(null);
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const sSummaryObj = useSelector(
    (state) => state.SliceBatchOut.value.SummaryObj
  );
  const sDetailObj = useSelector((state) => state.SliceBatchOut.value.HeadObj);
  const [Summary_Grid_Columns, setSummary_Grid_Columns] = useState([
    {
      field: "A_SheetId",
      headerName: "Sheet No",
      width: 150,
    },
    {
      field: "LocName",
      headerName: "Location",
      width: 200,
    },
    {
      field: "A_RefNo",
      headerName: "RefNo",
      width: 100,
    },
    {
      field: "A_Date",
      headerName: "Date",
      width: 300,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "A_Status",
      headerName: "Status",
      width: 200,
    },
  ]);
  // modal start

  const [sAttribut, setAttribute] = useState([
    {
      Branch: [],
      Document: [],
    },
  ]);
  const [showModal, setShowModal] = useState(false);
  const [showModalVersion, setShowModalVersion] = useState(false);

  // modal end

  const [Detail_Grid_columns, setDetail_Grid_columns] = useState([
    {
      field: "A_VocTyp",
      headerName: "Voucher Type",
      width: 150,
      hide: true,
    },

    {
      field: "A_VocNo",
      headerName: "Doc.No",
      width: 150,
    },
    {
      field: "VocName",
      headerName: "Voucher Name",
      width: 200,
    },
    {
      field: "A_PostDt",
      headerName: "Date",
      width: 110,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "A_Party",
      headerName: "Party Code",
      width: 150,
      hide: true,
    },
    {
      field: "PartyName",
      headerName: "Party Name",
      width: 250,
    },
    {
      field: "A_Br",
      headerName: "Branch Code",
      width: 150,
      hide: true,
    },
    {
      field: "BrName",
      headerName: "Branch Name",
      width: 110,
    },
    {
      field: "A_Loc",
      headerName: "Location Code",
      width: 150,
      hide: true,
    },
    {
      field: "LocName",
      headerName: "Location Name",
      width: 200,
    },
    {
      field: "TrnTyp",
      headerName: "Type",
      width: 100,
      hide: true,
    },
    {
      field: "TrnTypName",
      headerName: "Transaction",
      width: 200,
    },
    {
      field: "Status",
      headerName: "Status",
      width: 100,
    },
  ]);
  const [sSummaryGridRow, setSummaryGridRow] = useState([]);
  const [sVersionGridRow, setVersionGridRow] = useState([]);

  const fSummary_OnChange = (e) => {
    dispatch(
      Set_SummaryObj({
        ...sSummaryObj,
        [e.target.name]: e.target.value,
      })
    );
  };

  const fLoad = (e) => {
    Get_Load_Grid_Data(
      sSummaryObj?.Branch,
      sSummaryObj?.dateFrom,
      sSummaryObj?.dateTo,
      sSummaryObj?.Document,
      sSummaryObj?.Status
    );
    setShowModal(false);
  };

  const Get_Load_Grid_Data = async (xLoc, xDate1, xDate2, Document, Status) => {
    const vRdxUserInfoObj = vRdxUserInfo();
    var vSummaryObj = {
      v_Date1: moment(xDate1).format("MM/DD/YYYY"),
      v_Date2: moment(xDate2).format("MM/DD/YYYY"),
      v_DatetTyp: "A",
      v_Branch: xLoc,
      v_TrnTyp: Document,
      v_UserCd: vRdxUserInfoObj.UserID,
      v_Typ: Status,
    };
    const vItemSearch = await INVBTOUT_Summary_GETROW(vSummaryObj);

    if (vItemSearch?.status === 200) {
      if (vItemSearch?.data?.ResultSet?.length > 0) {
        const itemRows = vItemSearch?.data?.ResultSet?.map((obj, i) => ({
          ...obj,
          id: i + 1,

          // A_Date: moment(obj.A_Date).format("DD/MM/YYYY"),
        }));
        setSummaryGridRow(itemRows);
      } else {
        setSummaryGridRow([]);
      }
    }
  };

  const fRowCLick = async (item) => {
    const updatedRow = {
      ...item.row,
    };
    dispatch(Set_HeadObj(updatedRow));
    await GetSIDetailVersion(setVersionGridRow);

    setShowModalVersion(true);
  };
  const fRowCLickVersion = (item) => {
    let { DetailHead } = BatchOutRo();
    dispatch(
      Set_HeadObj_DetailHead_Update({
        ...DetailHead,
        Version: item.row.VS_Version,
        Status: item.row.VS_Status,
      })
    );
    setShowModalVersion(false);
    navigate("/BatchOutDetail");
  };

  const GetAttributes = async () => {
    const vRdxUserInfoObj = vRdxUserInfo();
    var vObj = {
      userCd: vRdxUserInfoObj.UserID,
    };
    const iAttributes = await INVBTOUT_Attribute_GETROW(vObj);
    if (iAttributes?.status === 200) {
      setAttribute(iAttributes?.data?.ResultSet);
      return iAttributes?.data?.ResultSet;
    } else {
      return [];
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onload = async () => {
    let iAttributeResp = await GetAttributes(setAttribute);

    let { SummaryObj } = BatchOutRo();

    dispatch(
      Set_SummaryObj({
        ...SummaryObj,
        Branch:
          SummaryObj.Branch == "" ||
          SummaryObj.Branch == undefined ||
          SummaryObj.Branch == null
            ? iAttributeResp?.Branch[0]?.UId || ""
            : SummaryObj.Branch,
        Document:
          SummaryObj.Document == "" ||
          SummaryObj.Document == undefined ||
          SummaryObj.Document == null
            ? iAttributeResp?.Document[0]?.UId || ""
            : SummaryObj.Document,
      })
    );
    Get_Load_Grid_Data(
      SummaryObj.Branch == "" ||
        SummaryObj.Branch == undefined ||
        SummaryObj.Branch == null
        ? iAttributeResp?.Branch[0]?.UId || ""
        : SummaryObj.Branch,
      SummaryObj?.dateFrom,
      SummaryObj?.dateTo,
      SummaryObj.Document == "" ||
        SummaryObj.Document == undefined ||
        SummaryObj.Document == null
        ? iAttributeResp?.Document[0]?.UId || ""
        : SummaryObj.Document,
      SummaryObj?.Status
    );
    // fLoad_Grid(setDetailGridData);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  useEffect(() => {
    LocationFocusOnLoad?.current?.focus();
  }, []);

  useEffect(() => {
    onload();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container-fluid my-3">
      <div className="Breadcrumbs d-flex justify-content-between align-items-center">
        <BreadCrumbs />
        <CmpButton
          xbtnName="Filter"
          xOnClick={() => {
            setShowModal(true);
          }}
          xVariant="contained"
          xSize="small"
        />
      </div>
      <div className="mt-1  ">
        <Box sx={{ height: "75vh", width: "100%" }}>
          {/* <DataGrid
            rowHeight={30}
            headerHeight={40}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
            }}
            rows={sSummaryGridRow}
            columns={Detail_Grid_columns}
            hideFooter={sSummaryGridRow.length < 100}
            onRowClick={fRowCLick}
            // components={{
            //   Toolbar: vMediaQuery ? "" : GridToolbar,
            // }}
          /> */}
          <SummaryTblCard
            data={sSummaryGridRow}
            onClick={(items) => {
              fRowCLick(items);
            }}
          />
        </Box>
      </div>
      {/* <CardSummary
        data={sSummaryGridRow}
        onClick={(items) => {
          fRowCLick(items);
        }}
      /> */}
      <GCModalV1
        height="220px"
        xsheight="220px"
        xOpen={showModal}
        fCloseModal={() => {
          setShowModal(false);
        }}
        xTitle="Filter"
        component={
          <>
            <Grid container spacing={2} className="align-items-center">
              <Grid item xs={6} className="bintransfer-data-date">
                <CmpDatePickerField001V1
                  xLabelText={"From"}
                  xValue={sSummaryObj?.dateFrom}
                  xOnChange={(newValue) => {
                    dispatch(
                      Set_SummaryObj({
                        ...sSummaryObj,
                        dateFrom: newValue.$d,
                      })
                    );
                  }}
                  xName={"dateFrom"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>
              <Grid item xs={6} className="bintransfer-data-date">
                <CmpDatePickerField001V1
                  xLabelText={"To"}
                  xValue={sSummaryObj?.dateTo}
                  xOnChange={(newValue) =>
                    dispatch(
                      Set_SummaryObj({
                        ...sSummaryObj,
                        dateTo: newValue.$d,
                      })
                    )
                  }
                  xName={"dateTo"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>
              <Grid item xs={6}>
                <CmpSelectFieldV1
                  xref={LocationFocusOnLoad}
                  xLabelText="Branch"
                  xValue={sSummaryObj?.Branch}
                  xOnChange={(event) => fSummary_OnChange(event)}
                  xName={"Branch"}
                  xData={sAttribut?.Branch}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={6}>
                <CmpSelectFieldV1
                  xLabelText="Document"
                  xValue={sSummaryObj?.Document}
                  xOnChange={(event) => fSummary_OnChange(event)}
                  xName={"Document"}
                  xData={sAttribut?.Document}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={6}>
                <CmpSelectFieldV1
                  xLabelText="Status"
                  xValue={sSummaryObj?.Status}
                  xOnChange={(event) => fSummary_OnChange(event)}
                  xName={"Status"}
                  xData={[
                    { Uid: "A", Name1: "All" },
                    { Uid: "P", Name1: "Pending" },
                  ]}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>

              <Grid
                item
                xs={6}
                className="bintransfet-data-load-btn text-center"
              >
                <CmpButton
                  xbtnName="Load"
                  xOnClick={fLoad}
                  xVariant="contained"
                  xSize="small"
                />
              </Grid>
            </Grid>
          </>
        }
      />

      <GCModalBatch
        xOpen={showModalVersion}
        fCloseModal={() => {
          setShowModalVersion(false);
          setVersionGridRow([]);
        }}
        xTitle="Batch Delivery Note"
        component={
          <>
            <div>
              {/* sDetailObj */}
              <Grid container spacing={2} className="align-items-center">
                <Grid item xs={6} md={2} className="bintransfer-data-date">
                  <CmpTextFieldV1
                    xLabelText="Voc.No"
                    xValue={sDetailObj?.A_VocNo}
                    xType={"text"} // text/number/password
                    xName={"A_VocNo"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                    // xOnKeyUp={xKey}
                  />
                </Grid>

                <Grid item xs={6} md={2}>
                  <CmpTextFieldV1
                    xLabelText="Date"
                    xValue={moment(sDetailObj?.A_PostDt).format("DD/MM/YYYY")}
                    xType={"text"} // text/number/password
                    xName={"A_PostDt"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                    // xOnKeyUp={xKey}
                  />
                </Grid>
                <Grid item xs={6} md={3}>
                  <CmpTextFieldV1
                    xLabelText="Party"
                    xValue={sDetailObj?.PartyName}
                    xType={"text"} // text/number/password
                    xName={"PartyName"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                    // xOnKeyUp={xKey}
                  />
                </Grid>
                <Grid item xs={6} md={1}>
                  <CmpTextFieldV1
                    xLabelText="Loc"
                    xValue={sDetailObj?.LocName}
                    xType={"text"} // text/number/password
                    xName={"LocName"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                    // xOnKeyUp={xKey}
                  />
                </Grid>

                <Grid
                  item
                  xs={6}
                  md={2}
                  className="bintransfet-data-load-btn text-center"
                >
                  <CmpTextFieldV1
                    xLabelText="Transaction"
                    xValue={sDetailObj?.TrnTypName}
                    xType={"text"} // text/number/password
                    xName={"TrnTypName"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                    // xOnKeyUp={xKey}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  md={2}
                  className="bintransfet-data-load-btn text-center"
                >
                  <CmpTextFieldV1
                    xLabelText="Status"
                    xValue={sDetailObj?.Status}
                    xType={"text"} // text/number/password
                    xName={"Status"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                    // xOnKeyUp={xKey}
                  />
                </Grid>
              </Grid>
            </div>
            {sVersionGridRow.length > 0 && (
              <CardSummary data={sVersionGridRow} onClick={fRowCLickVersion} />
            )}
            <div className="text-center mt-1">
              <CmpButton
                xbtnName="New"
                xOnClick={() => {
                  console.log({
                    sVersionGridRow: sVersionGridRow.every(
                      (item) => item.VS_Status === "POST"
                    ),
                    sVersionGridRow1: sDetailObj.Status === "POST",
                  });

                  let { DetailHead } = BatchOutRo();
                  dispatch(
                    Set_HeadObj_DetailHead_Update({
                      ...DetailHead,
                      DispatchDate1: new Date(),
                      Version: 0,
                      Status: "ENTER",
                    })
                  );
                  navigate("/BatchOutDetail");
                }}
                xVariant="contained"
                xSize="small"
                xDisabled={
                  // sVersionGridRow.length == 0 ||
                //  ( sVersionGridRow.every((item) => item.VS_Status === "POST") ||
                // sDetailObj.Status === "POST" || (sVersionGridRow.length > 0 && !sVersionGridRow.every((item) => item.VS_Status === "POST"))
                sDetailObj.Status === "POST"?true: sVersionGridRow.length == 0 ?false:
                  sVersionGridRow.every((item) => item.VS_Status === "POST")? false: true
                }
              />
            </div>
          </>
        }
      />
    </div>
  );
}
